import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Landing from "./routes/Landing";
import Build from "./routes/Build";
import Stage from "./routes/Stage";
import TeammatePage from "./routes/TeammatePage";
import Results from "./routes/Results";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/build" element={<Build />} />
        <Route path="/stage" element={<Stage />} />
        <Route path="/t/:id" element={<TeammatePage />} />
        <Route path="/results" element={<Results />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
